import {
  apiRequest,
  createPeriodeTunsus,
} from "../../../../../services/adapters/kepegawaian/revisiTunjanganKhususService";

class CreateRepository {
  fetchCreate = async (query) => {
    return await apiRequest(
      "post",
      createPeriodeTunsus,
      {
        body: query,
      },
      true
    );
  };
}

export default CreateRepository;
